import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../context/UserContext'
import { Form, Col,  } from 'react-bootstrap'
import { Dropdown } from 'primereact/dropdown'
import css from '../AnuncioForm.module.css'
import { linkApi } from '../../config'

export default function Years({ values, setFieldValue }) {
    const { user } = useContext(UserContext)
    const [years, setYears] = useState([])

    const handleDropdownChange = (e) => {
        setFieldValue('registration.year', e.target.value)
        setFieldValue('fuel.id', '')
        setFieldValue('segment.id', '')
        setFieldValue('engine.power_cv', '')
        setFieldValue('version.id', '')
    }

    useEffect(() => {
        let id = values.model.id

        const postData = async () => {
            const options = {
                method: 'GET',
                headers: {
                    authorization: 'Bearer ' + user.token,
                },
            }

            const res = await fetch(`${linkApi}/v1/cars/years/${id}`, options)
                .then((response) => response.json())
                .catch((err) => console.error(err))

            const ordenar = res.data
                .sort((a, b) => b - a)
                .map((index) => {
                    return {
                        id: parseInt(index),
                        name: index.toString(),
                    }
                })

            setYears(ordenar)
        }

        postData()
    }, [user.token, values.model.id])

    return (
        <div>
            <Form.Group as={Col} controlId="validationFormik03">
                <Form.Label className={css.label}>Anos</Form.Label>
                <Dropdown
                    value={parseInt(values.registration.year)}
                    onChange={handleDropdownChange}
                    options={years}
                    placeholder="Escolher"
                    optionLabel="name"
                    optionValue="id"
                    filter
                    // disabled
                    className="w-full md:w-14rem"
                    style={{ width: '-webkit-fill-available' }}
                />
            </Form.Group>
        </div>
    )
}
